import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Stack, DialogTitle, Typography, TextField, Button } from '@mui/material';

import { inviteMemberAtom } from '@/interfaces/member';

interface InviteDialogProps {
  onClose: () => void;
}

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function InviteDialog({ onClose }: InviteDialogProps) {
  const { mutate: invite, isPending, data: isSuccess } = useAtomValue(inviteMemberAtom);

  const [email, setEmail] = useState('');
  const { t } = useTranslation();

  const isEmailValid = email.length === 0 || emailRegex.test(email);
  const errorText = isEmailValid ? '' : t('Common.message.wrongEmailFormat');

  useEffect(() => {
    if (isSuccess === undefined) return;
    if (isSuccess) {
      onClose();
    } else {
      window.alert(t('Settings.message.inviteFailed'));
    }
  }, [isSuccess, onClose, t]);

  function onOkClick() {
    invite(email);
  }

  return (
    <Stack gap={2} sx={{ minWidth: 480, p: 3 }}>
      <DialogTitle sx={{ px: 0 }}>{t('Settings.label.inviteMember')}</DialogTitle>
      <Typography>{t('Settings.label.email')}</Typography>
      <TextField
        value={email}
        error={!isEmailValid}
        helperText={errorText}
        onChange={(e) => setEmail(e.target.value)}
      />

      <Stack direction="row" justifyContent="center" gap={3}>
        <Button variant="contained" onClick={onClose} sx={{ bgcolor: '#CCC', color: 'black' }}>
          {t('Common.label.cancel')}
        </Button>
        <Button
          variant="contained"
          disabled={email.trim().length === 0 || !isEmailValid || isPending}
          onClick={onOkClick}
          sx={{ bgcolor: 'info.main' }}
        >
          {t('Common.label.ok')}
        </Button>
      </Stack>
    </Stack>
  );
}
